'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _keyCode = require('appkit-react-utils/keyCode');

var _keyCode2 = _interopRequireDefault(_keyCode);

var _defaultButton = require('../Table/defaultButton');

var _defaultButton2 = _interopRequireDefault(_defaultButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pager = function (_Component) {
  _inherits(Pager, _Component);

  function Pager(props) {
    _classCallCheck(this, Pager);

    var _this = _possibleConstructorReturn(this, (Pager.__proto__ || Object.getPrototypeOf(Pager)).call(this, props));

    _initialiseProps.call(_this);

    var _props$current = props.current,
        current = _props$current === undefined ? 1 : _props$current;

    _this.state = {
      value: current
    };
    return _this;
  }

  _createClass(Pager, [{
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var current = nextProps.current;

      this.setState({ value: current });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          className = _props.className,
          current = _props.current,
          kind = _props.kind,
          onPageChange = _props.onPageChange,
          text = _props.text,
          pageNums = _props.pageNums,
          otherProps = _objectWithoutProperties(_props, ['style', 'className', 'current', 'kind', 'onPageChange', 'text', 'pageNums']);

      var shape = kind === 'numeric' ? 'circle' : 'default';
      return _react2.default.createElement(
        'li',
        Object.assign({
          className: (0, _classnames2.default)('', _defineProperty({
            'a-page a-page-number': kind !== 'carousel',
            'a-carousel': kind === 'carousel'
          }, '' + shape, shape))
        }, otherProps),
        this.renderPager()
      );
    }
  }]);

  return Pager;
}(_react.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleInputChange = function (e) {
    var value = Number(e.target.value);
    if (value < 0 || value > Number(_this2.props.pageNums) || Number.isNaN(value)) {
      return;
    }
    _this2.setState({ value: value });
  };

  this.onKeyDown = function (e) {
    var onPageChange = _this2.props.onPageChange;

    switch (e.keyCode) {
      case _keyCode2.default.ENTER:
        // enter
        e.preventDefault && e.preventDefault();
        onPageChange && onPageChange(_this2.state.value);
        break;
      case _keyCode2.default.ARROW_UP:
        onPageChange && onPageChange(_this2.state.value - 1);
        break;
      case _keyCode2.default.ARROW_DOWN:
        onPageChange && onPageChange(_this2.state.value + 1);
        break;
      default:
        break;
    }
  };

  this.onBlur = function (e) {
    if (e) {
      e.preventDefault && e.preventDefault();
    }

    var value = _this2.state.value;
    if (value === 0) {
      value = 1;
    }

    var onPageChange = _this2.props.onPageChange;

    onPageChange && onPageChange(value);
  };

  this.onClick = function (v) {
    var onPageChange = _this2.props.onPageChange;

    onPageChange && onPageChange(v);
  };

  this.renderPagerWithFields = function () {
    var _props$pageNums = _this2.props.pageNums,
        pageNums = _props$pageNums === undefined ? 1 : _props$pageNums;
    var value = _this2.state.value;

    return _react2.default.createElement(
      'span',
      null,
      _react2.default.createElement('input', {
        type: 'text',
        onChange: _this2.handleInputChange,
        onKeyDown: _this2.onKeyDown,
        onBlur: _this2.onBlur,
        className: 'a-current-page',
        value: value,
        pattern: '\\d+'
      }),
      ' ',
      _react2.default.createElement(
        'span',
        { className: 'page-text' },
        'of ',
        pageNums
      )
    );
  };

  this.renderNumericPager = function (page) {
    var _ClassNames2;

    var _props2 = _this2.props,
        current = _props2.current,
        onPageChange = _props2.onPageChange;

    var buttonClasses = (0, _classnames2.default)('pager-numeric', (_ClassNames2 = {}, _defineProperty(_ClassNames2, 'active', page === current), _defineProperty(_ClassNames2, 'unclickable-pager', !onPageChange), _ClassNames2));
    return _react2.default.createElement(
      'a',
      { className: buttonClasses, onClick: _this2.onClick.bind(_this2, page) },
      page
    );
  };

  this.renderCarousel = function (page) {
    var current = _this2.props.current;

    var buttonClasses = (0, _classnames2.default)('a-pager-carousel', _defineProperty({}, 'active', page === current));
    return _react2.default.createElement(_defaultButton2.default, {
      className: buttonClasses,
      onClick: _this2.onClick.bind(_this2, page)
    });
  };

  this.renderPager = function () {
    var _props3 = _this2.props,
        kind = _props3.kind,
        text = _props3.text;

    if (kind === 'fields') {
      return _this2.renderPagerWithFields();
    } else if (kind === 'numeric') {
      return _this2.renderNumericPager(text);
    } else if (kind === 'carousel') {
      return _this2.renderCarousel(text);
    } else {
      return null;
    }
  };
};

Pager.propTypes = {
  kind: _propTypes2.default.string,
  onPageChange: _propTypes2.default.func,
  current: _propTypes2.default.number,
  text: _propTypes2.default.any,
  pageNums: _propTypes2.default.number,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string
};

Pager.displayName = 'Pager';

exports.default = Pager;